import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from "react";
import { getClassNameFactory, useFetch, useFragmentFetch } from "../../utilities";
import { Loading } from "../index";
import { Alert } from "../../elements";
import { AlertState } from "../../elements/Alert";
import Alignment, { HorizontalAlignments } from "../Alignment";
export var ContentFragment = function ContentFragment(_ref) {
  var contentFragmentPath = _ref.contentFragmentPath,
      loadingMessage = _ref.loadingMessage,
      loadingFailedMessage = _ref.loadingFailedMessage,
      loadingFailedComponent = _ref.loadingFailedComponent,
      isContentFragmentUpdate = _ref.isContentFragmentUpdate,
      onLoadingComplete = _ref.onLoadingComplete,
      handleVersion = _ref.handleVersion;
  var contentFragmentURL = "/content/ue-settings/endpointsMapping/contentFragment.json".concat(contentFragmentPath, ".json");

  var _ref2 = isContentFragmentUpdate ? useFragmentFetch(contentFragmentURL, {}) : useFetch(contentFragmentURL, {}),
      _ref3 = _slicedToArray(_ref2, 3),
      response = _ref3[0],
      isLoading = _ref3[1],
      error = _ref3[2];

  var getClassName = getClassNameFactory(ContentFragment.displayName); // endpoint returns an array of objects, result is expected in the first one

  var _ref4 = response && response.length !== 0 ? response[0] : {},
      _ref4$content = _ref4.content,
      content = _ref4$content === void 0 ? "" : _ref4$content,
      _ref4$version = _ref4.version,
      version = _ref4$version === void 0 ? "" : _ref4$version;

  var isSuccessState = handleVersion ? Boolean(content) && Boolean(version) : Boolean(content); // If the version is expected then we check that it's coming in the response.
  // Otherwise the component should fail

  useEffect(function () {
    if (!isLoading && handleVersion && isSuccessState) {
      handleVersion(version);
    }
  }, [isLoading, handleVersion, isSuccessState, version]);
  var isErrorState = Boolean(error) || !(isLoading || isSuccessState); // Run callback when fragment loaded

  useEffect(function () {
    if (!isLoading && onLoadingComplete) {
      onLoadingComplete(isErrorState);
    }
  }, [isLoading, onLoadingComplete, isErrorState]);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, isLoading && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "loading"
    })
  }, /*#__PURE__*/React.createElement(Loading, {
    text: loadingMessage
  })), isErrorState && (loadingFailedComponent ? loadingFailedComponent : /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "error"
    })
  }, /*#__PURE__*/React.createElement(Alignment, {
    horizontal: HorizontalAlignments.CENTER
  }, /*#__PURE__*/React.createElement(Alert, {
    alertState: AlertState.FAILURE
  }, loadingFailedMessage)))), response && isSuccessState && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
    /* use dangerouslySetInnerHTML here,
       since data from content fragment is html*/
    ,
    dangerouslySetInnerHTML: {
      __html: response[0].content
    }
  }));
};
ContentFragment.displayName = "ContentFragment";